import {setArrayPath} from "./setArrayPath";

export const errorHandler = (errors, path, containerArrayPath) => {
    let err = '';
    let currentPath = containerArrayPath ? setArrayPath(path, containerArrayPath) : path;
    errors.forEach(error => {
        let errField = `${currentPath.split('.')[0]}.${error.field}`;
        let replaced = errField.replace(/\[/g, '.').replace(/]/g, '');
        if(replaced === currentPath){
            err = error.text
        }
    });
    return err;
};